import { handleGetRequest } from "./http.service";
import { PaginationDataRes } from "types/http.type";
import { EmailLog, EmailLogFilters, EmailLogStats } from "types/emailLog.type";
import { PaginationParams } from "types/general.interface";

const buildQuery = (params: Record<string, string | number | undefined>) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== "") query.set(key, String(value));
  });
  return query.toString();
};

export const getEmailLogs = async (
  pagination: PaginationParams,
  filters: EmailLogFilters
) => {
  const qs = buildQuery({ ...pagination, ...filters });
  return await handleGetRequest<PaginationDataRes<EmailLog[]>>(
    `/admins/email-logs?${qs}`
  );
};

export const getEmailLogStats = async (filters: EmailLogFilters) => {
  const qs = buildQuery({ ...filters });
  return await handleGetRequest<EmailLogStats>(`/admins/email-logs/stats?${qs}`);
};
